<template>
	<view class="photos-viewer" v-if="visible">
		<vue-easy-lightbox
		      :visible="visible"
		      :imgs="imgs"
		      :index="index"
		      @hide="handleHide"
		    />
	</view>
</template>

<script>
	import VueEasyLightbox from 'vue-easy-lightbox';
	export default {
		name:'photos-viewer',
		components:{
			VueEasyLightbox
		},
		props: {
			visible: {
				type: Boolean,
				default:false
			},
			imgs:{
				type:Array,
				default:[]
			},
			index:{
				type:Number,
				default:0
			}
		},
		data() {
			return {
				
				// visible: false,
				// index: 0,
			}
		},
		methods: {
			 handleHide() {
			     this.$emit('show',false)
			},
		},
	}
</script>

<style>
</style>